import React, {useEffect} from "react";

const AcceptDenyModal = ({statement, acceptCallback, denyCallback, closeCallback, style}) => {

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                closeCallback && closeCallback();
            }
        }

        window.addEventListener("keydown", handleKeyDown)

        return () => window.removeEventListener("keydown", handleKeyDown)
    }, []);

    return (
        <div onClick={(e) => e.stopPropagation()}
            className="box"
            style={{
                backgroundColor: "#f5f5f5",
                display: "flex",
                flexDirection: "row",
                marginTop: "1rem",
                alignItems: "center",
                ...style
            }}
        >
            <p>{statement}</p>
            <div style={{display: "flex"}}>
                <img
                    style={{marginLeft: "0.2rem"}}
                    src="check_mark.png"
                    alt="Checkmark"
                    className="icon-style"
                    onClick={acceptCallback}
                />
                <img
                    src="cancel.png"
                    alt="Cancel"
                    className="icon-style"
                    onClick={denyCallback}
                />
            </div>
        </div>
    )
}

export default AcceptDenyModal;